// General
import "./Period.scss";
// Assets
import FlutterLogo from "../../assets/Logo/Flutter-Logo-Temp.png";

const Period = () => {
  // Render
  return (
    <div className="period-container">
      <div className="image-container">
        {/* <img className="cover-img" src={NightskyCover} alt="1st section" /> */}
      </div>

      <div className="description-container">
        <div className="description-label">Description</div>
        <div className="description">
          A momentjs inspired date package for Flutter/Dart
        </div>
      </div>

      <div className="info-container">
        <div className="tools-container">
          <div className="tools-label">Tools Used</div>
          <div className="tools-logo-container">
            <img
              className="flutter-logo"
              src={FlutterLogo}
              alt="Flutter Logo"
            />
          </div>
        </div>

        <div className="timeline-container">
          <div className="timeline-label">Expected Timeline</div>
          <div className="timeline">3 Months</div>
        </div>
      </div>

      <div className="additional-info-container">
        <div className="role-container">
          <div className="role-label">Role</div>
          <div className="role">Flutter Developer</div>
        </div>
      </div>

      <div className="progress-container">
        <div className="progress-label">Progress</div>

        <div className="image-group">
          {/* Architecture */}
          <div className="sub-progress-label">Architecture</div>

          {/* Design */}
          <div className="sub-progress-label">Design</div>
        </div>
      </div>
    </div>
  );
};

export default Period;
